"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
exports.default = (function (props) { return (jsx_runtime_1.jsxs("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [jsx_runtime_1.jsx("path", { d: "M18 9C18 7.4087 17.3679 5.88258 16.2426 4.75736C15.1174 3.63214 13.5913 3 12 3C10.4087 3 8.88258 3.63214 7.75736 4.75736C6.63214 5.88258 6 7.4087 6 9C6 16 3 18 3 18H21C21 18 18 16 18 9Z", strokeLinecap: "round", strokeLinejoin: "round" }, void 0),
        jsx_runtime_1.jsx("path", { d: "M15 18C14.6951 18.9125 14.2575 19.6699 13.731 20.1964C13.2045 20.7229 12.6076 21 12 21C11.3924 21 10.7955 20.7229 10.269 20.1964C9.74247 19.6699 9.30487 18.9125 9 18", strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0)); });
